import {
  Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverBody, PopoverArrow,
  Button, VStack, HStack, Box, Tag,
} from "@chakra-ui/react";
import CDS from "design-system";
import type { GridJourney, GridTaskTemplate } from "../types";

interface Props {
  hiddenJourneys: GridJourney[];
  hiddenTemplates: GridTaskTemplate[];
  onRestoreJourney: (id: number) => void;
  onRestoreTemplate: (id: number) => void;
}

export default function HiddenItemsPopover({
  hiddenJourneys, hiddenTemplates, onRestoreJourney, onRestoreTemplate,
}: Props) {
  const total = hiddenJourneys.length + hiddenTemplates.length;

  if (total === 0) return null;

  return (
    <Popover placement="bottom-end" isLazy>
      <PopoverTrigger>
        <Button size="sm" variant="outline">
          Hidden <Tag size="sm" ml={2}>{total}</Tag>
        </Button>
      </PopoverTrigger>
      <PopoverContent w="320px">
        <PopoverArrow />
        <PopoverHeader fontWeight="medium">Hidden from view</PopoverHeader>
        <PopoverBody>
          <VStack align="stretch" spacing={3}>
            {hiddenJourneys.length > 0 && (
              <Box>
                <CDS.Text10 color="gray.500" textTransform="uppercase" mb={1}>
                  New hires
                </CDS.Text10>
                <VStack align="stretch" spacing={1}>
                  {hiddenJourneys.map((j) => (
                    <HStack key={j.id} justify="space-between">
                      <CDS.Text12 noOfLines={1}>{j.newHire?.fullName ?? "Unknown"}</CDS.Text12>
                      <Button size="xs" variant="ghost" onClick={() => onRestoreJourney(j.id)}>
                        Show
                      </Button>
                    </HStack>
                  ))}
                </VStack>
              </Box>
            )}
            {hiddenTemplates.length > 0 && (
              <Box>
                <CDS.Text10 color="gray.500" textTransform="uppercase" mb={1}>
                  Tasks
                </CDS.Text10>
                <VStack align="stretch" spacing={1}>
                  {hiddenTemplates.map((t) => (
                    <HStack key={t.id} justify="space-between">
                      <CDS.Text12 noOfLines={1}>{t.name}</CDS.Text12>
                      <Button size="xs" variant="ghost" onClick={() => onRestoreTemplate(t.id)}>
                        Show
                      </Button>
                    </HStack>
                  ))}
                </VStack>
              </Box>
            )}
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
